import { NativeModules } from "react-native";
const {
  RNRestart
} = NativeModules;
export default RNRestart;
//# sourceMappingURL=index.js.map